/**
 * Extracts and formats a filename from an Azure Blob Storage URL
 * 
 * @param {string} url - The full Azure Blob Storage URL (e.g., "https://storageaccount.blob.core.windows.net/container/1234567890-myfile.pdf")
 * @param {boolean} fullName - If true, returns the full filename; if false, truncates long filenames (default: false)
 * @returns {string} The cleaned filename with optional truncation
 * 
 * @example
 * // Returns "myfile.pdf"
 * fileNameFromAzureUrl("https://storageaccount.blob.core.windows.net/container/1234567890-myfile.pdf")
 * 
 * @example
 * // Returns "my-ve...e.pdf" (if name exceeds FILE_NAME_MAX_LENGTH)
 * fileNameFromAzureUrl("https://storageaccount.blob.core.windows.net/container/1234567890-my-very-long-filename.pdf")
 * 
 * @example
 * // Returns "my-very-long-filename.pdf" (full name)
 * fileNameFromAzureUrl("https://storageaccount.blob.core.windows.net/container/1234567890-my-very-long-filename.pdf", true)
 */
export const fileNameFromAzureUrl = (url) => {
  if (!url) return '';

  try {
    // Extract filename (strip query params)
    let filename = decodeURIComponent(url.split('/').pop().split('?')[0])
      .replace(/\+/g, ' ');

    // Handle multiple nested encodings (rare but possible)
    while (/%[0-9A-F]{2}/i.test(filename)) {
      const decoded = decodeURIComponent(filename);
      if (decoded === filename) break;
      filename = decoded;
    }

    // Remove upload timestamp prefix: backend uses Date.now() + "-" + originalname (see imgUpload.js blobName).
    // Date.now() is 13 digits (ms since epoch), so we strip exactly that pattern to avoid touching filenames like "123-456.pdf"
    filename = filename.replace(/^\d{13}-/, '').trim();

    return filename;

  } catch (e) {
    console.warn('Failed to decode filename:', e);
    return url.split('/').pop().split('?')[0].replace(/\+/g, ' ');
  }
};




